export class GraphEdge {
  constructor({ path, next, label, idSuffix = '' }) {
    this.arrowHeadType = 'arrowclosed';
    this.id = `${path}-${next}${idSuffix}`;
    this.label = label;
    this.labelStyle = { fontFamily: '"Klarna Text", "Klarna Sans", Helvetica, Arial, sans-serif' };
    this.source = path;
    this.target = next;
    this.type = 'straight';
  }
}

const mapEdgeLabel = label => {
  if (Array.isArray(label)) {
    return label.map((l, i) => mapEdgeLabel(l)).join(' && ');
  }
  return typeof label === 'string' && label;
};

export const mapEdgeElements = (steps = []) =>
  steps.reduce((acc, step) => {
    if (Array.isArray(step.next)) {
      return [
        ...acc,
        ...step.next.map(
          (n, i) =>
            new GraphEdge({
              path: step.path,
              next: n.path,
              label: mapEdgeLabel(n.condition),
              idSuffix: `-${i}`,
            }),
        ),
      ];
    }

    if (!step.next) return acc;

    return [...acc, new GraphEdge(step)];
  }, []);
